import React, { memo, type PropsWithChildren } from 'react';
import SectionMessage from '@atlaskit/section-message/message';
import type { SectionMessageProps } from '@atlaskit/section-message/types';

type LimitSectionMessageProps = PropsWithChildren<{
	appearance?: SectionMessageProps['appearance'];
}>;

export const LimitSectionMessage: React.FC<LimitSectionMessageProps> = memo(
	({ appearance = 'warning', children }) => {
		return <SectionMessage appearance={appearance}>{children}</SectionMessage>;
	},
);
